import * as classNames from 'classnames'
import * as React from 'react'
import * as moment from 'moment'
import { TripStatuses } from '../../constants/trip-statuses'
import history from '../../history'
import { IRecentTripObj, ITripStatus, ITripFilters, IRiderObject } from '../../types'
import Copy from '../icons/ui/Copy'
import ToolTip from '../ui/ToolTip'
import Van from '../icons/trips/Van'
import ToIcon from '../icons/trips/ToIcon'
import Handicafe from '../icons/trips/Handicafe'
import StatusTag from '../ui/StatusTag'
import ImageView from '../ui/ImageView'

interface IDashboardItemProps {
  trip: IRecentTripObj
  cloneTrip?: (e: any) => void
  waitingTime?: number
  resendRequest?: (tripId: string) => void
  getManyStatusesById?: (tripId: string) => Promise<ITripStatus[]>
  filters?: ITripFilters
  isArchived?: boolean
}

class DashboardItem extends React.Component<IDashboardItemProps> {
  constructor(props: IDashboardItemProps) {
    super(props)
  }

  public render() {
    const { trip, cloneTrip, filters, isArchived } = this.props
    const archived = isArchived ? isArchived : false
    const rider = trip.rider
    const operator = trip.operator
    const goToTrip = () => {
      history.push(`/trips/${this.props.trip.id}`)
    }
    moment.relativeTimeThreshold('m', 60)

    const addressParts = ((trip && trip.pickupLocation && trip.pickupLocation.fullAddress) || '').split(',')
    const shortAddress = addressParts[0] + ', ' + addressParts[1]
    let statusTime: string | undefined = trip.lastStatusAt
    // if (!statusTime && trip && trip.scheduledPickupTime) {
    //   statusTime = trip.scheduledPickupTime
    // }

    if (filters && filters.timeField === 'pickup') {
      statusTime = trip.scheduledPickupTime ? trip.scheduledPickupTime : trip.lastStatusAt
    }

    if (!rider) {
      return null
    }

    return (
      <div className='flex flex-column px1'>
        <div className='trips-user'>
          <div className=' flex cursor--pointer mt1 col-12'>
            {/* {trip.tripType === 'app' && <img className='mr1 mb2 w50 image' src='/images/trip-request/app-request.svg' />}
          {trip.tripType === 'import' && (
            <img className='mr1 mb2 w50 image' src='/images/trip-request/import-request.svg' />
          )}
          {trip.tripType === 'phone' && (
            <img className='mr1 mb2 w50 image' src='/images/trip-request/phone-request.svg' />
          )} */}
            {/* Trips Main  - Set Avatar*/}
            <ImageView
              entityId={rider ? rider.riderId : undefined}
              name={rider.firstName + ' ' + rider.lastName}
              isRounded={true}
              width='50px'
              height='50px'
            />
            {/* Trips Main  - Set Avatar*/}
            <div className='col-10 ml2 ' onClick={goToTrip}>
              <div className='flex col-12 items-center'>
                {rider && <div className='h5 flex w-100'>{`${rider.firstName} ${rider.lastName} `} </div>}
              </div>
              <div className='flex col-12 items-center'>
                {trip && <div className='h6 font-grey2 '>{shortAddress}</div>}
              </div>
              <div className='h6 font-grey2'>{this.props.trip.product.name}</div>
              <div className='flex items-center mt1'>
                <StatusTag status={trip.lastStatus || 'NO STATUS'} />
                {statusTime ? (
                  <ToolTip message={moment(statusTime).format('MMM Do, h:mm a')}>
                    <div className='ml2 h6 bold font-gray5'>{moment(statusTime).fromNow()}</div>
                  </ToolTip>
                ) : null}
                {operator ? (
                  <p className='ml1 h6 bold font-blue m0'>
                    by {operator.firstName} {operator.lastName}
                  </p>
                ) : null}
              </div>
            </div>
            <div title='Request Again' className='ml1 cursor--pointer'>
              {!archived ? <Copy onClick={cloneTrip} /> : null}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default DashboardItem



// WEBPACK FOOTER //
// ./src/components/trips/DashboardItem.tsx